import i18n from "../i18n";

export function untitledCaptureName() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${i18n.t("editor.untitled")}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
}
